import { Component, OnInit, ViewChild, Input } from "@angular/core"; import { Location } from "@angular/common";
import { Table } from 'primeng/table';
import { BreadcrumbService } from '../../app.breadcrumb.service';

import { RequisitionService } from '../../services/requisition-service';
import { RequisitionMin } from '../../entites/requisition-min';
import { MenuItem } from 'primeng/api/menuitem';
import { MessageService, LazyLoadEvent, ConfirmationService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

import { DialogService } from 'primeng/dynamicdialog';
import { EnvoiRequisitionComponent } from '../../controles/envoi-requisition.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ListeAchatService } from 'src/app/services/liste-achat-service';
import { CategorieMin, CategorieEntite } from 'src/app/entites/categorie';
import { CategorieService } from 'src/app/services/categorie-service';
import { EmployeEntite } from 'src/app/entites/employe';
import { EmployeService } from 'src/app/services/employe-service';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';
import { RoleEntite } from 'src/app/entites/role';
import { RequeteModifierRoles } from 'src/app/services/requetes/requete-modifier-roles';
import { Emprunt } from 'src/app/entites/emprunt';
import { environment } from "src/environments/environment";
import { Message, MessagesToToastObject } from "src/app/services/reponse-base";
import { EStatuts } from "src/app/entites/enums/statuts";
import { ThemeOption, ThemeService } from "src/app/services/theme.service";
import { EmplacementService } from "src/app/services/emplacement-service";
import { MembreEmplacement } from "src/app/entites/membre-emplacement";
import { SelectionEmplacementComponent } from "src/app/controles/selection-emplacement.component";
import { ModifierAttributsMembreEmplacementComponent } from "../emplacement/controles/modifier-attributs-membre-emplacement/modifier-attributs-membre-emplacement.component";
import { Emplacement } from "src/app/entites/emplacement";
import { PushSubscriptionService } from "src/app/services/push-subscription.service";

export interface LienCategorieEmploye {
    categorieId: number;
    nomCategorie: string;
    utilise: boolean;
    indObligatoire: boolean;
}

@Component({
    templateUrl: './detail-employe.component.html',
    styles: [`
        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

        .theme-dot {
            position: relative;
            width: 1.5rem;
            height: 1.5rem;
            border-radius: 50%;
            box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
            overflow: hidden;
        }

        .theme-dot-dark::after {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            width: 50%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.7);
        }

    `],
    providers: [MessageService, ConfirmationService, DialogService]
})
export class DetailEmployeComponent extends BaseComponent implements OnInit {

    employeId: number;
    employe: EmployeEntite;

    submitted: boolean;
    menu: MenuItem[];
    tabIndex = this.createParamSignal('tabIndex', 0);

    liensCategorie: LienCategorieEmploye[] = [];

    @ViewChild('dt') table: Table;

    rolesCharges: boolean = false;
    rolesEnErreur: boolean = false;
    rolesEmploye: RoleEntite[] = [];
    rolesDisponibles: RoleEntite[] = [];
    tousLesRoles: RoleEntite[] = [];
    rolesSelectionnes: RoleEntite[] = [];
    rolesAjoutSelectionnes: RoleEntite[] = [];
    dialogAjoutRolesVisible: boolean = false;

    // Tasks dialog properties
    dialogTachesVisible: boolean = false;
    roleSelectionne: RoleEntite | null = null;

    // Emprunts properties
    empruntsEmploye: Emprunt[] = [];
    chargementEmprunts: boolean = false;

    // Emplacements properties
    emplacementsEmploye: MembreEmplacement[] = [];
    chargementEmplacements: boolean = false;

    themes: ThemeOption[] = [];
    currentTheme: string = '';
    isDarkMode: boolean = false;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent, location: Location,
        private breadcrumbService: BreadcrumbService,
        private employeService: EmployeService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router,
        public themeService: ThemeService,
        private emplacementService: EmplacementService,
        private pushSubscriptionService: PushSubscriptionService) {

        super(sdb, profilService, route, routerService, appMain);
        this.breadcrumbService.setItems([
            { label: 'Employés', routerLink: '/employes' },
            { label: 'Profil' }
        ]);

        this.route.params.subscribe(params => {
            this.employeId = params.id as number;
        });
    }

    ngOnInit() {

        if (this.employeId != 0) {

            this.employeService.Obtenir(this.employeId).then(x => {
                this.employe = x.valeur;
                this.initialiserMenu();

                this.CompleterChargement();

                this.chargerRoles();
                this.chargerEmprunts();
                this.chargerEmplacements();
                this.initializeTheme();
            });
        } else {
            this.employe = {
                estSysteme: false,
                indVoirPhotoSurSurvole: true,
                indCouleursFond: true,
                statut: {
                    statutId: 0,
                    nom: 'Nouveau'
                }
            }
            this.initialiserMenu();

            this.Modifier();

            this.CompleterChargement();

        }
    }

    initialiserMenu() {
        this.menu = [
            {
                label: 'Retour', icon: 'pi pi-fw pi-angle-double-left', command: () => window.history.back(),
            },
            {
                label: 'Archiver', icon: 'pi pi-fw pi-trash', command: () => this.archiverEmploye(),
                visible: this.employe.statut.statutId != EStatuts.Archive && this.estAutorise('employe_modifier')
            },
            {
                label: 'Désarchiver', icon: 'pi pi-fw pi-undo', command: () => this.desarchiverEmploye(),
                visible: this.employe.statut.statutId == EStatuts.Archive && this.estAutorise('employe_modifier')
            },
            {
                label: 'Imiter les rôles',
                icon: 'pi pi-fw pi-shield',
                command: () => {
                    event.preventDefault();
                    event.stopPropagation();
                    this.impersoner(this.employe)
                },
                visible: this.estAutorise('admin_employes') && this.employe.employeId !== this.profilService.ProfilCourant().employeId && !this.profilService.EstEnModeImitation()
            },
        ];
    }

    btnModifier_click() {
        this.Modifier();
    }

    annuler() {
        this.Consulter();
        this.ngOnInit();
    }

    sauvegarder() {
        this.submitted = true;
        if (!this.valider()) {
            this.messageService.add({ severity: 'error', summary: 'Erreurs', detail: 'Veuillez corriger les erreurs de saisie.' });
            return;
        }
        if (this.employe.employeId) {
            this.employeService.Modifier(this.employe).then(res => {
                if (res.estUnSucces) {
                    this.employe = res.valeur;
                    this.sdb.ReinitialiserEmployes();
                    this.Consulter();
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Profil modifié avec succès' });
                } else {
                    res.messages.forEach(x => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                    });
                }
            });
        }
        else {
            this.employeService.Ajouter(this.employe).then(res => {
                if (res.estUnSucces) {
                    this.employe = res.valeur;
                    this.sdb.ReinitialiserEmployes();
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Employé ajouté avec succès' });

                } else {
                    res.messages.forEach(x => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                    });
                }
            });
        }

    }

    valider() {
        return this.employe.prenom
    }

    chargerRoles() {
        if (this.employe.employeId && this.estAutorise('employe_modifier')) {
            this.rolesCharges = false;

            // Charger tous les rôles disponibles
            this.employeService.ObtenirRoles().subscribe({
                next: roles => {
                    this.tousLesRoles = roles;

                    // Charger les rôles de l'employé
                    this.employeService.ObtenirRolesEmploye(this.employe.employeId).subscribe({
                        next: rolesEmploye => {
                            this.rolesEmploye = rolesEmploye;
                            this.mettreAJourRolesDisponibles();
                            this.rolesCharges = true;
                        }, error: error => {
                            this.rolesEnErreur = true;
                            this.rolesCharges = true;
                        }
                    });
                }, error: error => {
                    this.rolesEnErreur = true;
                    this.rolesCharges = true;
                }
            });
        }
    }

    mettreAJourRolesDisponibles() {
        if (this.tousLesRoles && this.rolesEmploye) {
            // Filtrer les rôles qui ne sont pas déjà attribués à l'employé
            this.rolesDisponibles = this.tousLesRoles.filter(role =>
                !this.rolesEmploye.some(r => r.roleId === role.roleId)
            );
        }
    }

    ouvrirDialogueAjoutRoles() {
        this.rolesAjoutSelectionnes = [];
        this.mettreAJourRolesDisponibles();
        this.dialogAjoutRolesVisible = true;
    }

    fermerDialogueAjoutRoles() {
        this.dialogAjoutRolesVisible = false;
        this.rolesAjoutSelectionnes = [];
    }

    filtrerRoles(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
        if (this.table) {
            this.table.filterGlobal(filterValue, 'contains');
        }
    }

    filtrerRolesDisponibles(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
        if (this.table && this.table.hasFilter()) {
            this.table.filterGlobal(filterValue, 'contains');
        }
    }

    ajouterRolesSelectionnes() {
        if (this.rolesAjoutSelectionnes && this.rolesAjoutSelectionnes.length > 0) {
            const request: RequeteModifierRoles = {
                employeId: this.employe.employeId,
                roleIds: this.rolesAjoutSelectionnes.map(r => r.roleId),
                operation: 'add',
                creeParId: this.employe.employeId
            };

            this.employeService.ModifierRoles(request).subscribe({
                next: success => {
                    if (success) {
                        // Ajouter les rôles sélectionnés à la liste des rôles de l'employé
                        this.rolesEmploye = [...this.rolesAjoutSelectionnes, ...this.rolesEmploye];
                        this.mettreAJourRolesDisponibles();
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Rôles ajoutés avec succès' });
                        this.fermerDialogueAjoutRoles();
                    } else {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Impossible d\'ajouter les rôles' });
                    }
                },
                error: error => {
                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue lors de l\'ajout des rôles' });
                }
            });
        }
    }

    supprimerRole(role: RoleEntite) {
        this.confirmationService.confirm({
            message: `Voulez-vous vraiment supprimer le rôle "${role.nom}" pour cet employé ?`,
            header: 'Confirmation de suppression',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                const request: RequeteModifierRoles = {
                    employeId: this.employe.employeId,
                    roleIds: [role.roleId],
                    operation: 'remove',
                    creeParId: this.employe.employeId
                };

                this.employeService.ModifierRoles(request).subscribe({
                    next: success => {
                        if (success) {
                            this.rolesEmploye = this.rolesEmploye.filter(r => r.roleId !== role.roleId);
                            this.mettreAJourRolesDisponibles();
                            this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Rôle supprimé avec succès' });
                        } else {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Impossible de supprimer le rôle' });
                        }
                    },
                    error: error => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue lors de la suppression du rôle' });
                    }
                });
            }
        });
    }

    impersoner(employe: EmployeEntite) {

        this.confirmationService.confirm({
            message: `Voulez-vous impersonner les rôles de ${employe.prenom} ${employe.nom} ? Vous aurez temporairement leurs rôles.`,
            header: 'Confirmation d\'impersonation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.profilService.ImpersonerEmploye(employe.employeId).subscribe({
                    next: () => {
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Mode imitation activé pour ${employe.prenom} ${employe.nom}` });
                        this.routerService.navigateByUrl('/');
                        window.location.reload();
                    }
                });
            },
            reject: () => {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Impersonation annulée' });
            }
        });
    }

    confirmerSuppressionRoles() {
        if (this.rolesSelectionnes && this.rolesSelectionnes.length > 0) {
            this.confirmationService.confirm({
                message: `Voulez-vous vraiment supprimer ${this.rolesSelectionnes.length} rôle(s) pour cet employé ?`,
                header: 'Confirmation de suppression',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    const request: RequeteModifierRoles = {
                        employeId: this.employe.employeId,
                        roleIds: this.rolesSelectionnes.map(r => r.roleId),
                        operation: 'remove',
                        creeParId: this.employe.employeId
                    };

                    this.employeService.ModifierRoles(request).subscribe({
                        next: success => {
                            if (success) {
                                // Filtrer les rôles supprimés
                                this.rolesEmploye = this.rolesEmploye.filter(
                                    role => !this.rolesSelectionnes.some(r => r.roleId === role.roleId)
                                );
                                this.rolesSelectionnes = [];
                                this.mettreAJourRolesDisponibles();
                                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Rôles supprimés avec succès' });
                            } else {
                                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Impossible de supprimer les rôles' });
                            }
                        },
                        error: error => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue lors de la suppression des rôles' });
                        }
                    });
                }
            });
        }
    }

    ouvrirAuth0Dashboard() {
        window.open(`${environment.auth0.urlGestionUtilisateurs}`, '_blank');
    }

    chargerEmprunts() {
        if (this.employeId && this.employeId != 0) {
            this.chargementEmprunts = true;
            this.employeService.ObtenirEmprunts(this.employeId).subscribe({
                next: (emprunts) => {
                    this.empruntsEmploye = emprunts;
                    this.chargementEmprunts = false;
                },
                error: (error) => {
                    console.error('Erreur lors du chargement des emprunts:', error);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: 'Une erreur est survenue lors du chargement des emprunts'
                    });
                    this.chargementEmprunts = false;
                }
            });
        }
    }

    chargerEmplacements() {
        if (this.employeId && this.employeId != 0) {
            this.chargementEmplacements = true;
            this.employeService.ObtenirEmplacements(this.employeId).subscribe({
                next: (emplacements) => {
                    this.emplacementsEmploye = emplacements;
                    this.chargementEmplacements = false;
                },
                error: (error) => {
                    console.error('Erreur lors du chargement des emplacements:', error);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: 'Une erreur est survenue lors du chargement des emplacements'
                    });
                    this.chargementEmplacements = false;
                }
            });
        }
    }

    ajouterEmplacement() {
        const ref = this.dialogService.open(SelectionEmplacementComponent, {
            header: 'Ajout d\'un emplacement',
            width: '60%'
        }).onClose.subscribe((resSelectionEmplacement: Emplacement) => {
            if (resSelectionEmplacement) {
                var membre: MembreEmplacement = { 
                    membreEmplacementId: 0,
                    employeId: this.employeId, 
                    employe: this.employe, 
                    emplacementId: resSelectionEmplacement.emplacementId,
                    emplacement: resSelectionEmplacement,
                    indChargeProjet: false, 
                    indResponsable: false, 
                    indReceptionRapportJournalier: false, 
                    indReceptionPriseHeures: false, 
                    indReceptionEntreesSorties: false,
                    indSst: false,
                    indAjoutAuto: false
                };
                const ref = this.dialogService.open(ModifierAttributsMembreEmplacementComponent, {
                    header: 'Modifier les attributs du membre',
                    width: '60%',
                    data: { membre: membre }
                }).onClose.subscribe((resMembre: MembreEmplacement) => {
                    if (resMembre) {
                        membre = resMembre;
                        this.emplacementService.AjouterMembre(membre.emplacementId, this.employeId, {
                            IndChargeProjet: membre.indChargeProjet,
                            IndResponsable: membre.indResponsable,
                            IndReceptionRapportJournalier: membre.indReceptionRapportJournalier,
                            IndReceptionPriseHeures: membre.indReceptionPriseHeures,
                            IndReceptionEntreesSorties: membre.indReceptionEntreesSorties,
                            IndSst: membre.indSst
                        }).subscribe({
                            next: () => {
                                this.chargerEmplacements();
                                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Emplacement ajouté.' });
                            },
                            error: (error) => this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue lors de l'ajout de l'emplacement: ${error.error}` })
                        });
                    }
                });
            }
        });
    }

    modifierAttributsEmplacement(membre: MembreEmplacement) {
        const ref = this.dialogService.open(ModifierAttributsMembreEmplacementComponent, {
            header: 'Modifier les attributs du membre',
            width: '60%',
            data: { membre: membre }
        }).onClose.subscribe((resMembre: MembreEmplacement) => {
            if (resMembre) {
                membre = resMembre;
                this.emplacementService.ModifierMembre(membre.emplacementId, this.employeId, {
                    IndChargeProjet: membre.indChargeProjet,
                    IndResponsable: membre.indResponsable,
                    IndReceptionRapportJournalier: membre.indReceptionRapportJournalier,
                    IndReceptionPriseHeures: membre.indReceptionPriseHeures,
                    IndReceptionEntreesSorties: membre.indReceptionEntreesSorties,
                    IndSst: membre.indSst
                }).subscribe({
                    next: () => {
                        this.emplacementsEmploye = this.emplacementsEmploye.map(val => val.emplacementId === membre.emplacementId ? membre : val);
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Attributions modifiées' });
                    },
                    error: (error) => this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue lors de la modification des attributions: ${error.error}` })
                });
            }
        });
    }

    supprimerEmplacement(membre: MembreEmplacement) {
        this.confirmationService.confirm({
            message: `Voulez-vous vraiment retirer l'employé de l'emplacement "${membre.emplacement.nom}" ?`,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.emplacementService.SupprimerMembre(membre.emplacementId, this.employeId).subscribe({
                    next: () => {
                        this.emplacementsEmploye = this.emplacementsEmploye.filter(val => val.emplacementId !== membre.emplacementId);
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Emplacement retiré' });
                    },
                    error: (error) => this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue lors du retrait de l'emplacement: ${error.error}` })
                });
            }
        });
    }

    getStatutSeverity(statutNom: string): string {
        if (!statutNom) return 'secondary';

        switch (statutNom.toLowerCase()) {
            case 'actif':
                return 'success';
            case 'en retard':
                return 'danger';
            case 'en attente':
                return 'warning';
            case 'archive':
                return 'secondary';
            default:
                return 'info';
        }
    }

    archiverEmploye() {
        this.confirmationService.confirm({
            message: 'Voulez-vous vraiment archiver cet employé ?',
            header: 'Confirmation de suppression',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.employeService.Supprimer(this.employe.employeId).subscribe({
                    next: (res: Message) => {
                        this.messageService.addAll(MessagesToToastObject(res));
                        this.employe.statut.statutId = 2;
                        this.employe.statut.nom = 'Archive';
                    },
                    error: (error: Message | Message[]) => {
                        this.messageService.addAll(MessagesToToastObject(error));
                    }
                });
            }
        });
    }

    desarchiverEmploye() {
        this.confirmationService.confirm({
            message: 'Voulez-vous vraiment désarchiver cet employé ?',
            header: 'Confirmation de désarchivage',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.employeService.DesarchiverEmploye(this.employe.employeId).subscribe({
                    next: (res: Message) => {
                        this.messageService.addAll(MessagesToToastObject(res));
                        this.employe.statut.statutId = 1;
                        this.employe.statut.nom = 'Actif';
                    }
                });
            }
        });
    }

    public ActiverEmploye() {
        this.employeService.ActiverEmploye(this.employe.employeId).subscribe({
            next: (res: Message) => {
                this.messageService.addAll(MessagesToToastObject(res));
            }
        });
    }

    initializeTheme(): void {
        try {
            this.themes = this.themeService.getThemes();
            this.currentTheme = this.themeService.getCurrentTheme();
            this.isDarkMode = this.themeService.isDarkMode();

            // Subscribe to theme changes
            this.themeService.currentTheme$.subscribe(theme => {
                this.currentTheme = theme;
                this.isDarkMode = this.themeService.isDarkMode();
            });
        } catch (error) {
            console.error('Error initializing theme:', error);
        }
    }

    onThemeChange(event: any): void {
        this.themeService.setTheme(event.value);
        this.employe.theme = event.value;
    }

    toggleDarkMode(): void {
        this.themeService.toggleDarkMode();
    }

    /// <summary>
    /// Opens the tasks dialog for a specific role
    /// </summary>
    /// <param name="role">The role to display tasks for</param>
    voirTachesRole(role: RoleEntite): void {
        this.roleSelectionne = role;
        this.dialogTachesVisible = true;
    }

    /// <summary>
    /// Closes the tasks dialog
    /// </summary>
    fermerDialogueTaches(): void {
        this.dialogTachesVisible = false;
        this.roleSelectionne = null;
    }

    validerCourrielHamel(): boolean {
        if (this.employe.courriel == null) return true;
        return this.employe.courriel.includes('@hamelconstruction.com');
    }

    activerNotificationsSysteme() {
        if (this.pushSubscriptionService.isPushEnabled) {
            this.pushSubscriptionService.subscribeToPushNotifications().subscribe((success) => {
                if (success) {
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Les notifications système sont activées. Vous recevrez des notifications même lorsque l\'application est fermée.' });
                } else {
                    this.messageService.add({ severity: 'warn', summary: 'Attention', detail: 'Impossible d\'activer les notifications push. Vérifiez que les notifications sont autorisées dans votre navigateur.' });
                }
            });
        } else {
            Notification.requestPermission().then(permission => {
                if (permission === 'granted') {
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Les notifications système sont activées' });
                }
            });
        }
    }

    get Notification(): typeof Notification {
        return Notification;
    }
}
